<button
    matRipple
    type="button"
    class="copy-button"
    ngxClipboard
    [cbContent]="copyText"
    [attr.aria-label]="label | translate"
    (cbOnSuccess)="onCopySuccess()"
    (click)="$event.stopPropagation()">
    <ui-kit-svg class="i-16" name="ic_copy"/>
</button>
